var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoading)?_c('div',{staticClass:"bga-2 position-absolute h-100 w-100 d-flex align-items-center justify-content-center"},[_c('span',{staticClass:"font-up-10"},[_vm._v("Loading ... ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }